<template>
    <div class="table-page">
        <ivuTable border :columns="table.columns" :data="data.plan_detail"></ivuTable>
    </div>
</template>

<script>
    import { Table as ivuTable } from 'iview';
    import tableTag from './k8tag';
    export default {
        props: {
            data: {
                required: true,
            },
        },
        created () {
            this.data.plan_detail = [ { content: this.data.plan_detail } ];
        },
        data () {
            let type = this.data.order_info.play_type;
            return {
                table: {
                    columns: [
                        {
                            title: '彩期',
                            minWidth: 90,
                            align: 'center',
                            className: 'touzhuxiang',
                            render: ( h, params ) => h( 'div', `${this.data.order_info.qishu}` ),
                        },
                        {
                            title: '投注选项',
                            align: 'center',
                            minWidth: 500,
                            className: 'touzhuxiang',
                            render: ( h, params ) => {
                                console.log('params', params)
                                let selectRedArr = [];
                                if ( this.data.order_info.prize_cash != 0 ) {
                                    selectRedArr = this.data.result.split( ',' );
                                }
                                return h( tableTag, {
                                    props: {
                                        row: params.row,
                                        isLottery: this.data.order_info.prize_cash != 0,
                                        select: {
                                            selectRedArr: selectRedArr,
                                        },
                                    },
                                } );
                            },
                        },
                        {
                            title: '彩果',
                            align: 'center',
                            minWidth: 200,
                            className: 'spzhi',
                            render: ( h, params ) => {
                                console.log('result', this.data.result.split( ',' ))
                                if ( this.data.order_info.prize_cash === 0 ) {
                                    return h( 'div', '未开奖' );
                                } else {
                                    let newArr = this.data.result.split( ',' );
                                    let row = {
                                        content: [
                                            {
                                                numeric: newArr
                                            },
                                        ],
                                    };
                                    return h( tableTag, {
                                        props: {
                                            row: row,
                                            isLottery: false,
                                            select: {
                                                selectRedArr: [],
                                            },
                                        },
                                    } );
                                }
                            },
                        },
                    ],
                },
            };
        },
        components: {
            tableTag, ivuTable,
        },
    };
</script>